<template>
    <div class="main_data_div">
        <div class="col-md-12  p-left-0 p-right-0 ">

            <div class="col-md-6 col-xs-6 p-left-0 ">
                <p class="location_icon_section_title p-bottom-8 " > Location </p>
            </div>
            <div class="col-md-6 col-xs-6 p-right-0">
                <a href="#"   class=" float-right " data-toggle="modal" data-target="#openLocationComponentAsPopup" @click="emitEventBus('onLoadOtherComponent')"  >
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_3768_41969)">
                                <path d="M14.06 9.02L14.98 9.94L5.92 19H5V18.08L14.06 9.02ZM17.66 3C17.41 3 17.15 3.1 16.96 3.29L15.13 5.12L18.88 8.87L20.71 7.04C21.1 6.65 21.1 6.02 20.71 5.63L18.37 3.29C18.17 3.09 17.92 3 17.66 3ZM14.06 6.19L3 17.25V21H6.75L17.81 9.94L14.06 6.19Z" fill="#2E4051"/>
                            </g>
                            <defs>
                                <clipPath id="clip0_3768_41969">
                                    <rect width="24" height="24" fill="white"/>
                                </clipPath>
                            </defs>
                        </svg>
                </a>
            </div>

        </div>



        <div class="row" >
            <div class="col-md-12"  v-for="(single_address, key) in  allLocationsInsideItem"  >


                <div   class="  p-bottom-10 p-left-0 location-container-with-alpha mb-12 col-xs-12"  style=" display: flex; padding-right: 3px;" >
                      <span class="p-right-20 p-top-13 " v-if="allLocationsInsideItem.length > 1">
                             <a :href="`https://www.google.com.au/maps?q=${single_address.text_address}`" target="_blank" style="    text-decoration: none;">
                                   <div class=" location_icon_section_div" >   {{ String.fromCharCode((key + 1) + 64) }}  </div>
                             </a>
                     </span>

                    <span class="p-right-20 p-top-13 " v-else>
                                <a :href="`https://www.google.com.au/maps?q=${single_address.text_address}`" target="_blank">
                                      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect width="32" height="32" rx="16" fill="#008CFA" fill-opacity="0.15"/>
                                                    <g clip-path="url(#clip0_3764_102176)">
                                                        <path
                                                            d="M16 16C14.9 16 14 15.1 14 14C14 12.9 14.9 12 16 12C17.1 12 18 12.9 18 14C18 15.1 17.1 16 16 16ZM22 14.2C22 10.57 19.35 8 16 8C12.65 8 10 10.57 10 14.2C10 16.54 11.95 19.64 16 23.34C20.05 19.64 22 16.54 22 14.2ZM16 6C20.2 6 24 9.22 24 14.2C24 17.52 21.33 21.45 16 26C10.67 21.45 8 17.52 8 14.2C8 9.22 11.8 6 16 6Z"
                                                            fill="#2E4051"/>
                                                    </g>
                                                    <defs>
                                                        <clipPath id="clip0_3764_102176">
                                                            <rect width="24" height="24" fill="white" transform="translate(4 4)"/>
                                                        </clipPath>
                                                     </defs>
                                      </svg>

                                </a>
                      </span>



                    <span style="width: 100%">
                    <b  class="marker_label_title" v-if="single_address.marker_label &&  single_address.marker_label  == companyAddressLabel.address_label">
                        {{  companyAddressLabel.short_address_label }}     </b>
                    <b  class="marker_label_title" v-else-if="single_address.marker_label " >
                        {{ single_address.marker_label }}     </b>
                    <b  class="marker_label_title" v-else> {{ companyAddressLabel.short_address_label }} </b>
                        <input type="hidden" name="lat[]"  :value="single_address.address_lat"/>
                        <input type="hidden" name="lon[]"  :value="single_address.address_lon"/>
                        <input type="hidden" name="state[]"  :value="single_address.state"/>
                        <input type="hidden" name="postcode[]" :value="single_address.postcode"/>
                        <input type="hidden" name="suburb[]" :value="single_address.suburb"/>
                        <input type="hidden" name="unit_lot_number[]" :value="single_address.unit_lot_number"/>
                        <input type="hidden" name="street_address[]" :value="single_address.street_address"/>
                        <input type="hidden" name="street_number[]" :value="single_address.street_number"/>
                    <br>
                        <a :href="`https://www.google.com.au/maps?q=${single_address.text_address}`"  v-if="single_address.text_address"  target="_blank" class="marker_label_link">
                            <span v-if="single_address.text_address" >{{ single_address.text_address }}
                                <span v-if="single_address.property_type"> ({{ single_address.property_type}}) </span> </span>
                        </a>
                       <br/>
                         <a :href="`https://www.google.com.au/maps?q=${single_address.address_lat},${single_address.address_lon}`"
                             v-if="single_address.address_lat &&  single_address.address_lat !=0" target="_blank" style="text-decoration: none;">
                            <span>({{ single_address.address_lat }} , {{ single_address.address_lon }})</span>
                         </a>


                     </span>
                    <span  v-if="!iSMobileDeviceData" style="padding: 4% 0% 0px 5%; width: 100%; text-align: right;">
                          <div>
                                <a v-if="!iSMobileDeviceData" href="#" @click="initMapModal($event)"  aria-hidden="true" data-toggle="modal" :data-target="`#mapModal${key}`"><i class="fa fa-map-marker"></i><span style="font-size: 14px; font-weight: 600;"> View map </span></a>
                          </div>
                    </span>

                </div>

                <!--                    <a :href="`https://www.google.com.au/maps?q=${single_address.address_lat},${single_address.address_lon}`" target="_blank" style="  text-decoration: none;">-->
                <!--                        <span> view google map </span>-->
                <!--                    </a>-->




                <div v-if="showMapPopup" class="modal  confirmation-popup" tabindex="-1" role="dialog" :id="`mapModal${key}`">
                    <div class="modal-dialog confirmation-popup-width" role="document">
                        <div class="modal-content">
                            <div class="modal-header new-design">
                                <h5 class="modal-title d-inline"> Location </h5>
                                <svg class="close-icon clickable" data-dismiss="modal" aria-label="Close" width="24" height="24"
                                     viewBox="0 0 24 24" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M12 2C6.47 2 2 6.47 2 12C2 17.53 6.47 22 12 22C17.53 22 22 17.53 22 12C22 6.47 17.53 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM12 10.59L15.59 7L17 8.41L13.41 12L17 15.59L15.59 17L12 13.41L8.41 17L7 15.59L10.59 12L7 8.41L8.41 7L12 10.59Z" fill="#2E4051"/>

                                </svg>
                            </div>
                            <div class="modal-body">
                                <iframe
                                    width="100%"
                                    height="400px"
                                    frameborder="0"
                                    scrolling="no"
                                    marginheight="0"
                                    marginwidth="0"
                                    :src="`https://maps.google.com/maps?q=${single_address.address_lat},${single_address.address_lon}&z=12&amp;output=embed`"
                                >
                                </iframe>
                            </div>
                            <div class="modal-footer new-design">
                                <div class="col-md-12">


                                </div>
                            </div>
                        </div>
                    </div>
                </div>



            </div>

        </div>
    </div>


</template>

<script>


import {EventBus} from "@/events/event-bus";
import {iSMobileDevice} from "@/events/sharedMethods";

export default {
    name: "locationBoxInsideViewPage",
    props: {
        allLocationsInsideItem: null,
        companyAddressLabel: null,
        itemType: null,
    },
    data() {
        return {
            addressLabel_js:this.addressLabel,
            showMapPopup:false,
            iSMobileDeviceData:iSMobileDevice()
        }
    },

      mounted() {

        EventBus.$on('bookingAddressesChanged', (bookingAddresses) => {
            EventBus.$emit('updateBookingLocationsOnGoogleMap' );
            EventBus.$emit('updateBookingLocationsOnAvailableFieldworker' );
            this.allLocationsInsideItem = bookingAddresses;
        })
    },
    methods: {
      emitEventBus(){
        EventBus.$emit('onLoadOtherComponent')
      },
        iSMobileDevice,
        increase_count_locations_the_edit_booking(data) {
            if (data.length > 0) {
                /** this.add_mobile_input  ???   increase count of locations in the edit booking  **/
                this.add_mobile_input = data.length;
            }
        },
        initMapModal(event){
            event.preventDefault();
            this.showMapPopup = true;
            setTimeout(this.mapResize, 200);
        },
        mapResize(){

        },


    },
    watch: {

    }
}


</script>

<style scoped>
.location_icon_section{justify-content: center;display: flex; padding-right: 0;}
.location_icon_section_div{
    border-radius: 50%;
    background-color: var(--Blue-15, rgba(0, 140, 250, 0.15));
    display: inline;
    padding: 10px 15px;
    color: #000000;
    font-family: Roboto;
    font-size: 14px;
    text-decoration: none;
}
.location_icon_section_padding-right{  padding-right: 0; }
.location_icon_section_title{
    color: var(--Navy, #2E4051);
    /* Title/Left/H4 */
    font-family: Roboto;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px; /* 120% */
}


.marker_label_title{
    color: var(--Navy, #2E4051);
    /* Title/Left/H5 */
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px; /* 150% */
}

.marker_label_link{
    color: var(--Navy, #2E4051);
    /* Title/Left/H5 */
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    line-height: 24px;
    text-decoration: none;
}
 .locationMap {
     height: 300px;
 }
.modal-header.new-design {
    border-bottom: unset;
}

.has-error .form-control {
    border-color: #a94442 !important;
}

.modal-header.new-design .modal-title {
    font-family: 'Roboto', serif;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 24px;
    color: #2E4051;
    display: inline;
}

.modal-footer.new-design {
    border-top: unset;
    text-align: left;
    padding-top: 0px;
}

.close-icon {
    float: right;
}

.clickable {
    cursor: pointer;
}

.error-label {
    top: 8px;
    position: relative;
}

.btn.new-design {
    border-radius: 8px;
    padding: 12px 16px;
    font-family: 'Roboto', serif;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 16px;
    text-align: center;
    color: #FFFFFF;
}

.btn-primary.new-design {
    background: #2E4051 !important;
    float: right;
}
.btn-default.new-design{
    color: #2E4051
}

.form-control.new-design::placeholder {
    font-family: 'Roboto', serif;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
}

.form-control.new-design {
    padding: 16px;
    border: 1px solid #E0E2E5;
    border-radius: 8px;
    box-sizing: border-box;

    height: 56px;

    font-family: 'Roboto', serif;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
}

.btn.new-design {
    margin-bottom: unset;
}
@media (max-width: 768px) {
    .btn.new-design {
        width: 100%
    }
    .btn-default.new-design{
        margin-bottom: 10px;
    }
}
</style>